import { render } from "./GameSuggest.vue?vue&type=template&id=5e172c2f"
import script from "./GameSuggest.vue?vue&type=script&lang=ts"
export * from "./GameSuggest.vue?vue&type=script&lang=ts"
script.render = render

export default script